// PrivateRoute.js
// import React from "react";
// import { Navigate, Outlet } from "react-router-dom";
// import { jwtDecode } from "jwt-decode";

// const isTokenExpired = (token) => {
//   if (!token) return true;
//   try {
//     const decoded = jwtDecode(token);
//     const currentTime = Date.now() / 1000;
//     return decoded.exp < currentTime;
//   } catch (error) {
//     console.error("Token decoding error:", error);
//     return true; // If there's an error decoding, treat it as expired
//   }
// };

// const PrivateRoute2 = () => {
//   const token = localStorage.getItem("admintoken");
//   if (isTokenExpired(token)) {
//     localStorage.removeItem("admintoken");
//     return <Navigate to='/adminlogin' />;
//   }
//   return <Outlet />;
// };

// export default PrivateRoute2;

import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { url } from "../configlink";

const PrivateRoute2 = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(null); // null means "unknown/loading"
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await fetch(`${url}/api/auth/validateAdmin`, {
          method: "GET",
          credentials: "include", // Include cookies
        });
    
        if (response.status === 200) {
          setIsAuthenticated(true);
        } else if (response.status === 401 || response.status === 403) {
          setIsAuthenticated(false);
          // console.log("Token invalid or missing");
        } else {
          console.error("Unexpected response status:", response.status);
        }
      } catch (error) {
        console.error("Error checking authentication:", error);
        setIsAuthenticated(false);
      }
    };
    

    checkAuth();
  }, []);

  if (isAuthenticated === null) {
    // Show a loading spinner or placeholder while checking auth
    return <div>Loading...</div>;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/adminlogin" />;
};

export default PrivateRoute2;
